import { Injectable } from '@angular/core';
import { LocalStorageUtil, UsuarioAutenticado, UsuarioPermissoes } from "ui-shared";

@Injectable({
    providedIn: 'root'
})
export class Rules {
    private readonly permissoes: UsuarioPermissoes;
    private readonly usuarioLogado: UsuarioAutenticado;

    constructor() {
        this.permissoes = JSON.parse(LocalStorageUtil.obterPermissoes());
        this.usuarioLogado = JSON.parse(LocalStorageUtil.obterUsuario());
    }

    public possuiPermissao(role: string, exigeEdicao: boolean = false): boolean {
        if (role == EnumRoles.Suporte && this.usuarioLogado && !this.usuarioLogado.suporte) {
            return false;
        }

        if (role != EnumRoles.HabilitarSugestaoPreenchimento &&
            role != EnumRoles.HabilitarClassificacaoFiscal &&
            role != EnumRoles.Multiempresa &&
            this.usuarioLogado &&
            (this.usuarioLogado.suporte ||
                this.usuarioLogado.claims.find(claim => claim.type == "administrador")?.value == "True")) {
            return true;
        }

        if (!this.permissoes) {
            return false;
        }

        const possuiPerfilAdministrador = this.permissoes.perfis?.some(perfil =>
            perfil.perfilAcesso == EnumRoles.Administrador);
        const possuiPerfil = this.permissoes.perfis?.some(perfil => {
            let temEdicao = true;

            if (exigeEdicao) {
                temEdicao = perfil.permiteEdicao;
            }
            return perfil.perfilAcesso == role && temEdicao;
        });

        if(role == EnumRoles.Multiempresa){
            return possuiPerfil;
        }

        if(role == EnumRoles.HabilitarSugestaoPreenchimento){
            return possuiPerfil;
        }

        if(role == EnumRoles.HabilitarClassificacaoFiscal){
            return possuiPerfil;
        }

        return this.permissoes.administrador || possuiPerfilAdministrador || possuiPerfil;
    };
}

export enum EnumRoles {
    Suporte = 'Suporte',
    Administrador = 'Administrador',
    CadastroOperacional = 'CadastroOperacional',
    CadastroPdm = 'CadastroPdm',
    EnvioPortalUnico = 'EnvioPortalUnico',
    RetificadorProduto = 'RetificadorProduto',
    SaneamentoAnalista = 'SaneamentoAnalista',
    SaneamentoAuditor = 'SaneamentoAuditor',
    Multiempresa = 'Multiempresa',
    HabilitarSugestaoPreenchimentoCriativa = 'HabilitarSugestaoPreenchimentoCriativa',
    HabilitarSugestaoPreenchimento = 'HabilitarSugestaoPreenchimento',
    VinculacaoFabricante = 'VinculacaoFabricante',
    SaneamentoDetalhamento = 'SaneamentoDetalhamento',
    HabilitarClassificacaoFiscal = 'HabilitarClassificacaoFiscal',
    ImportacaoPortalUnico = 'ImportacaoPortalUnico',
}

export const EnumRolesDescricao = (role: EnumRoles): string => {
    let descricao: string;
    switch (role) {
        case EnumRoles.Administrador:
            descricao = 'Administrador'
            break;
        case EnumRoles.CadastroOperacional:
            descricao = 'Cadastro Operacional';
            break;
        case EnumRoles.CadastroPdm:
            descricao = 'Cadastro PDM';
            break;
        case EnumRoles.EnvioPortalUnico:
            descricao = 'Envio Portal Único';
            break;
        case EnumRoles.RetificadorProduto:
            descricao = 'Retificador Produto';
            break;
        case EnumRoles.SaneamentoAnalista:
            descricao = 'Saneamento Analista';
            break;
        case EnumRoles.SaneamentoAuditor:
            descricao = 'Saneamento Auditor';
            break;
        case EnumRoles.VinculacaoFabricante:
            descricao = 'Vinculação de Fabricante';
            break;
        case EnumRoles.SaneamentoDetalhamento:
            descricao = 'Saneamento Detalhamento';
            break;
        case EnumRoles.Multiempresa:
            descricao = 'Multiempresa';
            break;
        case EnumRoles.HabilitarSugestaoPreenchimento:
            descricao = 'Habilitar Sugestão Preenchimento';
            break;
        case EnumRoles.HabilitarSugestaoPreenchimentoCriativa:
            descricao = 'Habilitar Sugestão Preenchimento Criativa';
            break;
        case EnumRoles.HabilitarClassificacaoFiscal:
            descricao = 'Habilitar Classificação Fiscal';
            break;
        case EnumRoles.Suporte:
            descricao = 'Suporte';
            break;
        case EnumRoles.ImportacaoPortalUnico:
            descricao = 'Importação Portal Único';
            break;
        default:
            break;
    }

    return descricao;
}

export const EnumRolesPossuiOpcoesPermissao = (perfil: EnumRoles) => {
    switch (perfil) {
        case EnumRoles.Administrador:
        case EnumRoles.RetificadorProduto:
        case EnumRoles.EnvioPortalUnico:
        case EnumRoles.VinculacaoFabricante:
        case EnumRoles.ImportacaoPortalUnico:
            return false;
        case EnumRoles.CadastroOperacional:
        case EnumRoles.CadastroPdm:
        case EnumRoles.SaneamentoAnalista:
        case EnumRoles.SaneamentoAuditor:
        case EnumRoles.SaneamentoDetalhamento:
            return true;
        default:
            break;
    }
}

export enum EnumCondicional {
    PossuiAlguma = 1,
    PossuiTodas = 2
}
